import React from 'react';

interface ClickableHighlightProps {
    children: React.ReactNode;
    onClick?: () => void;
    className?: string;
    as?: keyof JSX.IntrinsicElements;
}

const ClickableHighlight: React.FC<ClickableHighlightProps> = ({
    children,
    onClick,
    className = 'highlight',
    as: Component = 'span',
}) => {
    const handleClick = (e: React.MouseEvent) => {
        if (onClick) {
            e.preventDefault();
            e.stopPropagation();
            onClick();
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            e.stopPropagation();
            onClick();
        }
    };

    if (onClick) {
        return React.createElement(
            Component,
            {
                className,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                tabIndex: 0,
                role: 'button',
                'aria-label': 'Clique para navegar',
                style: { cursor: 'pointer' },
            },
            children,
        );
    }

    return React.createElement(Component, { className }, children);
};

export default ClickableHighlight;
